import { Avatar, Chip } from "@mui/material";

interface IChipExternalLinkProps {
    label: string;
    url: string;
}

const ChipExternalLink = (props: IChipExternalLinkProps) => {

    const {label, url} = props;
    const domain = new URL(url).hostname;
    const faviconUrl = `https://www.google.com/s2/favicons?sz=64&domain=${domain}`;

    return (
        <Chip
            avatar={<Avatar src={faviconUrl} alt={domain} />}
            label={label || domain}
            clickable
            onClick={() => window.open(url, "_blank")}
            sx={{
                fontWeight: 600,
                backgroundColor: "#f5f5f5",
                "&:hover": {
                backgroundColor: "#e0e0e0",
                textDecoration: "underline",
                },
            }}
            />
    );
}

export default ChipExternalLink;